import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';

export const bottomContentsSupplier = (
  <div className="refrigerants-supplier">
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Inputting supplier data
    </StyledHeading>
    <StyledParagraph $largeText>
      This method uses emissions data obtained directly from your suppliers, aligning with the GHG Protocol’s preference
      for supplier-specific information.
    </StyledParagraph>
    <StyledParagraph $largeText $bold>
      Total absolute emissions (e.g., total kg CO₂e for the quantity of product purchased during the reporting period)
    </StyledParagraph>
    <ul>
      <li>
        <StyledParagraph $largeText>
          Carbon intensity data (e.g., kg CO₂e per unit of product or service)
        </StyledParagraph>
      </li>
      <li>
        <StyledParagraph $largeText>Calculated using your own emissions factors</StyledParagraph>
      </li>
      <li>
        <StyledParagraph $largeText>
          Reported as either intensity (e.g. kg CO₂e/unit) or total absolute emissions (e.g. total tonnes CO₂e)
        </StyledParagraph>
      </li>
    </ul>
    <StyledParagraph $largeText>
      This flexibility allows you to calculate emissions based on the level of detail your suppliers provide. If using
      intensity, you’ll also need usage data (e.g. quantity or distance); if using absolute emissions, no calculation is
      needed.
    </StyledParagraph>
    <StyledParagraph $largeText $bold>
      Use this if:
    </StyledParagraph>
    <StyledParagraph $largeText>
      Your suppliers provide emissions data, either as intensity or total emissions.
    </StyledParagraph>
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Need help entering supplier emissions data?
    </StyledHeading>
    <StyledParagraph $largeText>
      There are two ways to input emissions from suppliers in this category, depending on the type of data they’ve
      provided:
    </StyledParagraph>
    <ol>
      <li>
        <StyledParagraph $largeText $bold>
          Supplier intensity value/unit
        </StyledParagraph>
        <StyledParagraph $largeText $noMargin>
          If the supplier has shared emissions as an <b>intensity value/unit</b>, for example, “2.5 kg CO₂e per litre of
          diesel” - enter the intensity figure and the total quantity purchased during the reporting period so that the
          system can calculate total emissions for this emissions source from this specific supplier.
        </StyledParagraph>
      </li>
      <li>
        <StyledParagraph $largeText $bold>
          Supplier absolute emissions
        </StyledParagraph>
        <StyledParagraph $largeText $noMargin>
          If your supplier has already calculated and reported <b>absolute emissions</b> for their supply to you - for
          example, “10 tonnes CO₂e for diesel purchased ”, you can input that total amount directly. This is useful when
          the supplier has done the full emissions calculation for their specific products provided to you.
        </StyledParagraph>
      </li>
    </ol>
    <StyledParagraph $largeText $bold>
      Tip:
    </StyledParagraph>
    <StyledParagraph $largeText>
      Always check that the data you're entering corresponds to the exact quantity of goods or services received during
      the reporting period. This ensures accurate carbon accounting and avoids double counting.
    </StyledParagraph>
  </div>
);
